import { useCallback, useMemo } from 'react';
import { useAppStore } from 'store/hooks';
import Modal from 'utils/packages/Modal';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import TopUpGiaAccountModal from '../components/TopUpGiaAccountModal';
import { selectShowISATransfers, selectTradingAccount } from '../reducers/selectors';
import { IsaAllowanceFormatted, JisaAllowanceFormatted } from '../constants';
import { blockInvestActionOnWeb } from '../webGate';
const strings = {
    allowanceMaxedTitle: `You’ve reached your annual allowance`,
    isaAllowanceMaxedSubtitle: `You’ve already deposited ${IsaAllowanceFormatted} this tax year. You can add more once the new tax year begins.`,
    jisaAllowanceMaxedSubtitle: `You’ve already deposited ${JisaAllowanceFormatted} this tax year. You can add more once the new tax year begins.`,
    okay: 'Okay',
};
/** Legacy name. It is for both GIA and ISA. */
export const useDepositToGIA = (flow) => {
    const store = useAppStore();
    const navigation = useMainStackNavigation();
    const onDeposit = useCallback(() => {
        if (blockInvestActionOnWeb('Add money'))
            return;
        const state = store.getState();
        const tradingAccount = selectTradingAccount(state);
        if (!tradingAccount)
            return;
        const { accountType, id } = tradingAccount.account;
        const remainingAllowance = 
        // eslint-disable-next-line no-nested-ternary
        accountType === 'ISA'
            ? tradingAccount.account.isaRemainingAllowanceAfterPending
            : accountType === 'JISA'
                ? tradingAccount.account.jisaRemainingAllowanceAfterPending
                : undefined;
        if (remainingAllowance && remainingAllowance.value <= 0) {
            Modal.showConfirmation({
                title: strings.allowanceMaxedTitle,
                subtitle: accountType === 'ISA' ? strings.isaAllowanceMaxedSubtitle : strings.jisaAllowanceMaxedSubtitle,
                confirmButtonTitle: strings.okay,
            });
            return;
        }
        // The modal only adds a second option (ISA transfer) for funded ISAs, so otherwise go straight to the deposit.
        const canTransferIsa = accountType === 'ISA' && tradingAccount.hasFunded && selectShowISATransfers(state);
        if (canTransferIsa && flow !== 'onboarding') {
            TopUpGiaAccountModal.show(accountType, id, flow);
        }
        else {
            navigation.navigate('AddMoneyToTradingAccount', { tradingAccountId: tradingAccount.account.id });
        }
    }, [store, flow]);
    return useMemo(() => ({ onDeposit }), [onDeposit]);
};
